export const APPLICATION_TOAST_CONTAINER_ID = "APPLICATION_TOAST_CONTAINER_ID";
export const TABLE_TOAST_CONTAINER_ID = "TABLE_TOAST_CONTAINER_ID";
export const TOAST_SUCCESS = "TOAST_SUCCESS";
export const TOAST_ERROR = "TOAST_ERROR";
export const TOAST_WARNING = "TOAST_WARNING";
